module.exports = __webpack_public_path__ + "assets/img/js.0bd104da.svg";